import Vue from 'vue'
import Vuex from 'vuex'
import { Cabinet, Dossier, FolderTreeNode, CachedFolderTreeNode } from '../interfaces/interfaces'
import { AxiosInstance } from 'axios';

Vue.use(Vuex)

interface State
{
    currentCabinet: Cabinet | null;
    currentDossier: Dossier | null;
    linkedDossiers: Dossier[],
    cabinets: Array<Cabinet>;
    successMessage: string;
    errorMessage: string;
    loginFormVisible: boolean;
    cabinetFormVisible: boolean;
    cabinetsVisible: boolean;
    capabilities: Array<string>;
    hasAI: boolean;
    repertoiresHierarchyHistory: Record<string, CachedFolderTreeNode>;
    sharedAxiosInstance: AxiosInstance | null;
}

const state: State = {
    currentCabinet: null,
    currentDossier: null,
    linkedDossiers: [],
    cabinets: Array<Cabinet>(),
    successMessage: '',
    errorMessage: '',
    loginFormVisible: false,
    cabinetFormVisible: false,
    cabinetsVisible: false,
    capabilities: [],
    hasAI: false,
    repertoiresHierarchyHistory: {},
    sharedAxiosInstance: null,
};

export default new Vuex.Store({
    state: state,
    mutations:
        {
        setCabinets(state, cabinets: Cabinet[])
        {
            state.cabinets = cabinets;
        },

        addCabinet(state, cabinet: Cabinet)
        {
            const nextId = state.cabinets.length ? state.cabinets[state.cabinets.length-1]!.id! + 1 : 1;
            cabinet.id = nextId;
            state.cabinets.push(cabinet);
        },

        updateCabinet(state, payload)
        {
            const { cabinet } = payload;
            const index = state.cabinets.findIndex((c: Cabinet) => {
                return c.id == cabinet.id;
            });

            if(state.currentCabinet && state.currentCabinet.id == cabinet.id)
            {
                state.currentCabinet = cabinet;
            }

            Vue.set(state.cabinets, index, cabinet);
        },

        deleteCabinet(state, cabinet: Cabinet)
        {
            const index = state.cabinets.findIndex((c: Cabinet) => {
                return c.nom = cabinet.nom;
            });

            console.log(state.cabinets);
            state.cabinets.splice(index, 1);
            console.log(state.cabinets);
        },

        setCurrentCabinet(state, cabinet: Cabinet)
        {
            state.currentCabinet = cabinet;
        },

        setUsername(state, username: string)
        {
            if(state.currentCabinet)
            {
                state.currentCabinet.credentials.username = username;
            }
        },

        setPassword(state, password: string)
        {
            if(state.currentCabinet)
            {
                    state.currentCabinet.credentials.password = password;
            }
        },

        setCurrentDossier(state, dossier: Dossier)
        {
            state.currentDossier = dossier;
        },

        setLinkedDossiers(state, dossiers: Dossier[])
        {
            state.linkedDossiers = dossiers;
        },

        setSuccessMessage(state, message: string)
        {
            state.successMessage = message;
        },

        setErrorMessage(state, message: string)
        {
            state.errorMessage = message;
        },

        setLoginFormVisible(state, visible: boolean)
        {
            state.loginFormVisible = visible;
        },

        setCabinetFormVisible(state, visible: boolean)
        {
            state.cabinetFormVisible = visible;
        },

        setCabinetsVisible(state, visible: boolean)
        {
            state.cabinetsVisible = visible;
        },

        setCapabilities(state, capabilities: Array<string>)
        {
            state.capabilities = capabilities;
        },

        setHasAI(state, hasAI: boolean)
        {
            state.hasAI = hasAI;
        },

        addRepertoiresHierarchy(state, payload: { dossierId: string; repertoiresHierarchy: FolderTreeNode[] })
        {
            const now = Date.now()

            Vue.set(state.repertoiresHierarchyHistory, payload.dossierId, {
                repertoiresHierarchy: payload.repertoiresHierarchy,
                ts: now
            })

            const keys = Object.keys(state.repertoiresHierarchyHistory)
            if (keys.length > 30) {
                let oldestKey = keys[0]
                let oldestTs  = state.repertoiresHierarchyHistory[oldestKey].timestamp

                for (const k of keys.slice(1)) {
                    const entryTs = state.repertoiresHierarchyHistory[k].timestamp
                    if (entryTs < oldestTs) {
                        oldestTs  = entryTs
                        oldestKey = k
                    }
                }

                Vue.delete(state.repertoiresHierarchyHistory, oldestKey)
            }
        },

        setIsLoggedIn(state, payload)
        {
            const { nom, isLoggedIn } = payload;
            const index = state.cabinets.findIndex((c: Cabinet) => {
                return c.nom = nom;
            });
            const cabinet = state.cabinets.find((c: Cabinet) => {
                return c.nom = nom;
            });

            cabinet!.credentials.isLoggedIn = isLoggedIn;

            Vue.set(state.cabinets, index, cabinet);
        },

        setSharedAxiosInstance(state, axiosInstance: AxiosInstance)
        {
            state.sharedAxiosInstance = axiosInstance;
        }
    },
    actions:
    {
        setErrorMessage(context, message: string)
        {
            context.commit('setErrorMessage', message);
            setTimeout(() => {
                context.commit('setErrorMessage', '');
            }, 2000);
        },

        setSuccessMessage(context, message: string)
        {
            context.commit('setSuccessMessage', message);
            setTimeout(() => {
                context.commit('setSuccessMessage', '');
            }, 2000);
        },

        newLogin({ commit, state })
        {
            commit('setLoginFormVisible', true);
            commit('setCabinetFormVisible', false);
            commit('setCabinetsVisible', false);
        },
    },
    getters: {
        normalizedCabinetUrl(state) 
        {
            return state.currentCabinet!.url.replace(/\/+$/, '');
        },

        getRepertoiresHierarchyHistoryFor: (state) => (dossierId: string) => {
            const entry = state.repertoiresHierarchyHistory[dossierId]
            return entry
                ? entry.repertoiresHierarchy
                : null
        }
    },
    modules:
    {
    }
})
